<template>
  <div class="ps-current">
    <aside
      class="ps-current__side"
      :class="{ 'has-prepend': $slots['side-prepend'] }"
    >
      <div v-if="$slots['side-prepend']" class="ps-current__side-prepend">
        <slot name="side-prepend" />
      </div>
      <div class="ps-current__side-title">浏览模块</div>
      <button
        v-for="m in modules"
        :key="m.id"
        type="button"
        class="ps-current__side-item"
        :class="{ active: activeId === m.id }"
        @click="selectModule(m.id)"
      >
        <span class="ps-current__side-text">{{ m.title }}</span>
        <i v-if="activeId === m.id" class="ps-current__side-arrow" />
      </button>
    </aside>

    <section class="ps-current__main">
      <div class="ps-current__main-head">
        <span class="ps-current__main-bar" />
        <h3 class="ps-current__main-title">{{ activeTitle }}</h3>
        <!-- <span class="ps-current__main-ver">{{ versionTip }}</span> -->
      </div>
      <div
        v-if="changeHint && !isSnapshotMode"
        class="ps-current__hint"
        @click="goRequests"
      >
        {{ changeHint }}
      </div>

      <a-spin :spinning="loading">
        <div v-if="!loading && isEmpty" class="ps-current__empty">
          暂无该模块资料
        </div>

        <!-- 基本信息：两列一行，整行底部分割线 -->
        <div v-else-if="viewMode === 'fields'" class="ps-current__fields">
          <div
            v-for="(row, rIdx) in fieldRows"
            :key="'fr-' + rIdx"
            class="ps-current__field-row"
          >
            <div
              v-for="item in row"
              :key="item.key"
              class="ps-current__field"
            >
              <span class="ps-current__field-label">{{ item.label }}</span>
              <span class="ps-current__field-value">
                <button
                  v-if="item.clickable && item.value"
                  type="button"
                  class="ps-current__field-value is-link"
                  @click="onFieldClick(item)"
                >
                  {{ item.value }}
                </button>
                <template v-else>{{ item.value }}</template>
                <a
                  v-if="item.evidence"
                  class="ps-current__evidence"
                  @click.prevent="showFieldEvidence(item)"
                >佐证</a>
              </span>
            </div>
            <!-- 奇数个字段时右侧占位，保证底线拉满整行 -->
            <div
              v-if="row.length === 1"
              class="ps-current__field ps-current__field--placeholder"
            />
          </div>
        </div>

        <!-- 列表模块：对齐 dataUpload 的 a-table -->
        <div v-else-if="viewMode === 'table'" class="ps-current__table-wrap">
          <a-table
            class="ps-current__atable"
            style="text-align: center"
            :locale="{ emptyText: '暂无数据' }"
            :columns="antColumns"
            :data-source="tableRows"
            :bordered="true"
            :pagination="tablePagination"
            rowKey="id"
            :scroll="tableScroll"
            @change="onTableChange"
          >
            <template slot="seq" slot-scope="text, record, index">
              {{ (pageNo - 1) * pageSize + index + 1 }}
            </template>
            <span
              class="flex flex-around"
              slot="action"
              slot-scope="text, record"
            >
              <div
                class="ps-current__act"
                @click="showEvidence(record)"
              >
                <span>佐证材料</span>
              </div>
              <div class="ps-current__act" @click="seeRecord(record)">
                <span>查看</span>
              </div>
            </span>
          </a-table>
        </div>
      </a-spin>
    </section>

    <div class="preview-pop-box" v-if="showVideo">
      <div class="preview-boxs" style="height: 600px">
        <videopreview :sj="videoData" @closePreview="showVideo = false" />
      </div>
    </div>
    <div class="preview-pop-box" v-if="showEvidenceBox">
      <div class="preview-boxs">
        <evidencelist
          :title="evidenceQuery.title"
          :dataid="String(evidenceQuery.dataId || '')"
          :code="evidenceQuery.code"
          :isEdit="true"
          :id="String(applyId || '')"
          @closePreview="showEvidenceBox = false"
        />
      </div>
    </div>
    <!-- 文件预览：独立高层弹窗，避免被「查看」弹窗挡住 -->
    <a-modal
      :visible="showPdf"
      :footer="null"
      :closable="false"
      :maskClosable="false"
      :keyboard="true"
      :zIndex="5000"
      width="960px"
      wrapClassName="ps-file-preview-modal"
      :destroyOnClose="true"
      :dialogStyle="{ top: '40px', paddingBottom: '0' }"
      @cancel="showPdf = false"
    >
      <div class="ps-file-preview-body">
        <newpreview
          :previewUrl="previewUrl"
          :dialogTitle="previewTitle"
          @closePreview="showPdf = false"
        />
      </div>
    </a-modal>
    <!-- 工作室现状：列表模块查看弹窗 -->
    <course-add-teacher ref="courseAddTeacher" />
    <studio-add-teacher ref="studioAddTeacher" />
    <brand-add-teacher ref="brandAddTeacher" />
    <pp-found-source ref="ppFoundSource" />
    <pp-found-pay ref="ppFoundPay" />
    <pp-add-annual-plan ref="ppAddAnnualPlan" @preview-file="onChildPreviewFile" />
    <pp-add-activity ref="ppAddActivity" />
    <pp-add-team-build ref="ppAddTeamBuild" />
    <pp-add-educating-people ref="ppAddEducatingPeople" />
    <pp-add-achievement ref="ppAddAchievement" />
    <pp-add-propaganda ref="ppAddPropaganda" />
    <pp-add-effect ref="ppAddEffect" />
    <!-- 工作室现状：列表模块查看弹窗 -->
    <studio-add-teach-rearch ref="studioAddTeachRearch" />
    <studio-add-source ref="studioAddSource" />
    <studio-add-capital ref="studioAddCapital" />
    <studio-add-scientifice ref="studioAddScientifice" />
    <studio-add-activity-plan
      ref="studioAddActivityPlan"
      @preview-file="onChildPreviewFile"
    />
    <studio-add-result ref="studioAddResult" />
    <studio-add-active ref="studioAddActive" />
    <studio-add-team-build ref="studioAddTeamBuild" />
    <studio-add-base ref="studioAddBase" />
    <studio-add-base-active ref="studioAddBaseActive" />
    <studio-add-honor ref="studioAddHonor" />
    <studio-add-brand ref="studioAddBrand" />
  </div>
</template>

<script>
import { getAction } from "@/api";
import { getModuleChangeCount, sumPendingReviewNum } from "@/api/auditTask.js";
import { FIELD_LABELS, FILE_VIEW_MAP } from "@/components/auditPage/data.js";
import {
  getModuleConfigByApplyType,
  AUDIT_STATE_META,
} from "./moduleConfig.js";
import {
  getModuleDataSource,
  BASIC_EXTRA_FIELDS,
} from "./moduleDataSource.js";
import { getModuleTableColumns } from "./moduleTableColumns.js";
import newpreview from "@/components/common/newpreviews";
import videopreview from "@/components/common/videopreview";
import evidencelist from "@/components/common/evidencelist";
import courseAddTeacher from "@/components/szMicroClassFileupload/addTeacher.vue";
import studioAddTeacher from "@/components/szStudioFileupload/addTeamTeach.vue";
import brandAddTeacher from "@/components/educationalBrandFileupload/addTeamTeach.vue";
import ppFoundSource from "@/components/educationalBrandFileupload/addSource.vue";
import ppFoundPay from "@/components/educationalBrandFileupload/addCapitalExpenditure.vue";
import PpAddAnnualPlan from "@/components/educationalBrandFileupload/addAnnualPlan.vue";
import PpAddActivity from "@/components/educationalBrandFileupload/addActive.vue";
import PpAddTeamBuild from "@/components/educationalBrandFileupload/addBrandBuild.vue";
import PpAddEducatingPeople from "@/components/educationalBrandFileupload/addEducatingPeople.vue";
import PpAddAchievement from "@/components/educationalBrandFileupload/addAchievement.vue";
import PpAddPropaganda from "@/components/educationalBrandFileupload/addPropaganda.vue";
import PpAddEffect from "@/components/educationalBrandFileupload/addEffect.vue";
import studioAddTeachRearch from "@/components/szStudioFileupload/addTeachRearch.vue";
import studioAddSource from "@/components/szStudioFileupload/addSource.vue";
import studioAddCapital from "@/components/szStudioFileupload/addCapitalExpenditure.vue";
import studioAddScientifice from "@/components/szStudioFileupload/addScientificeRearch.vue";
import studioAddActivityPlan from "@/components/szStudioFileupload/addActivityPlan.vue";
import studioAddResult from "@/components/szStudioFileupload/addResult.vue";
import studioAddActive from "@/components/szStudioFileupload/addActive.vue";
import studioAddTeamBuild from "@/components/szStudioFileupload/addTeamBuild.vue";
import studioAddBase from "@/components/szStudioFileupload/addBase.vue";
import studioAddBaseActive from "@/components/szStudioFileupload/addBaseActive.vue";
import studioAddHonor from "@/components/szStudioFileupload/addHonor.vue";
import studioAddBrand from "@/components/szStudioFileupload/addBrand.vue";

/** 现状列表模块：操作列（查看 + 佐证材料） */
const ROW_VIEW_MODULES = {
  // 工作室
  GZSTUANDUI: { title: "工作室团队", ref: "studioAddTeacher" },
  GZSJIAOYANQINGKUANG: { title: "教研情况", ref: "studioAddTeachRearch" },
  GZSZIJINYUSUAN: { title: "资金预算", ref: "studioAddSource" },
  GZSZIJINZICHU: { title: "资金支出", ref: "studioAddCapital" },
  GZSKEYANQINGKUANG: { title: "科研情况", ref: "studioAddScientifice" },
  GZSHUODONGFANGAN: { title: "活动方案", ref: "studioAddActivityPlan" },
  GZSBIAOZHIXINGCHENGGUO: { title: "标志性成果", ref: "studioAddResult" },
  GZSKCZSSZKC: {
    title: "思政课程与课程思政大格局",
    ref: "studioAddActive",
  },
  GZSTUANDUIJIANSHE: { title: "团队建设", ref: "studioAddTeamBuild" },
  GZSSHIJIANJIDI: { title: "思政实践基地", ref: "studioAddBase" },
  GZSJIDIHUODONG: { title: "基地活动", ref: "studioAddBaseActive" },
  GZSRONGYU: { title: "荣誉", ref: "studioAddHonor" },
  PEIYUPINPAI: { title: "培育品牌", ref: "studioAddBrand" },
  // 微课
  WKTUANDUI: { title: "思政微课团队成员", ref: "courseAddTeacher" },
  // 品牌
  PPTUANDUI: { title: "品牌团队", ref: "brandAddTeacher" },
  PPZHIJINYUSUAN: { title: "品牌资金预算", ref: "ppFoundSource" },
  PPZHIJINSHIYONG: { title: "品牌资金使用", ref: "ppFoundPay" },
  PPNIANDUJIAHUAN: { title: "年度计划", ref: "ppAddAnnualPlan" },
  PPHUODONG: { title: "品牌活动", ref: "ppAddActivity" },
  PPJIANSHE: { title: "品牌建设", ref: "ppAddTeamBuild" },
  PPSIZHENGYUREN: { title: "思政育人", ref: "ppAddEducatingPeople" },
  PPCHENGGUO: { title: "品牌成果", ref: "ppAddAchievement" },
  PPXUANCHUAN: { title: "品牌宣传", ref: "ppAddPropaganda" },
  PPXIAOGUO: { title: "品牌效果", ref: "ppAddEffect" },
};

/** 现状：左侧浏览模块 + 右侧只读详情（对齐设计稿，不再内嵌填报表单） */
export default {
  name: "CurrentStatusPanel",
  components: {
    newpreview,
    videopreview,
    evidencelist,
    courseAddTeacher,
    studioAddTeacher,
    brandAddTeacher,
    ppFoundSource,
    ppFoundPay,
    PpAddAnnualPlan,
    PpAddActivity,
    PpAddTeamBuild,
    PpAddEducatingPeople,
    PpAddAchievement,
    PpAddPropaganda,
    PpAddEffect,
    studioAddTeachRearch,
    studioAddSource,
    studioAddCapital,
    studioAddScientifice,
    studioAddActivityPlan,
    studioAddResult,
    studioAddActive,
    studioAddTeamBuild,
    studioAddBase,
    studioAddBaseActive,
    studioAddHonor,
    studioAddBrand,
  },
  props: {
    applyId: {
      type: String,
      required: true,
    },
    applyType: {
      type: [String, Number],
      default: "1",
    },
    /** 主单数据（可从父级传入，减少重复请求） */
    project: {
      type: Object,
      default: null,
    },
    /** 传入则只读渲染该快照，不再请求业务表 */
    snapshotState: {
      type: Object,
      default: null,
    },
    snapshotMode: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      activeId: "",
      applyData: {},
      listRows: [],
      nestCache: {},
      pageNo: 1,
      pageSize: 10,
      total: 0,
      /** 专业三级名称缓存（category / subclass / major） */
      majorNames: { category: "", subclass: "", major: "" },
      /** 课程类型字典 value → title */
      courseTypeMap: {},
      /** 品牌文化级联树 id → name（对齐 dataUpload el-cascader） */
      brandLabelMap: {},
      /** 品牌文化树（用于路径 id → name） */
      brandLabelTree: [],
      brandLabelText: "",
      /** 文件/视频/佐证预览（必须在 data 中声明，否则 Vue2 不响应） */
      showPdf: false,
      previewUrl: "",
      previewTitle: "",
      showVideo: false,
      videoData: {},
      showEvidenceBox: false,
      evidenceRecord: {},
      evidenceQuery: {
        title: "",
        code: "",
        dataId: "",
      },
      changeHint: "",
    };
  },
  computed: {
    type() {
      return String(this.applyType);
    },
    config() {
      return getModuleConfigByApplyType(this.type);
    },
    modules() {
      return this.config.sideModules || [];
    },
    activeModule() {
      return this.modules.find((m) => m.id === this.activeId) || null;
    },
    activeTitle() {
      return (this.activeModule && this.activeModule.title) || "";
    },
    dataSource() {
      return getModuleDataSource(this.activeId, this.type);
    },
    fieldLabels() {
      const map = (FIELD_LABELS[this.type] &&
        FIELD_LABELS[this.type][this.activeId]) ||
        {};
      return map;
    },
    isRowViewModule() {
      return !!ROW_VIEW_MODULES[this.activeId];
    },
    evidenceTitle() {
      const conf = ROW_VIEW_MODULES[this.activeId];
      return (conf && conf.title) || this.activeTitle || "佐证材料";
    },
    fileViewMap() {
      const byType = FILE_VIEW_MAP[this.type] || {};
      return byType[this.activeId] || {};
    },
    versionTip() {
      const p = this.applyData || {};
      const ver =
        p.version || p.applyVersion || p.currentVersion || "";
      const stateMeta = AUDIT_STATE_META[String(p.auditState)] || {};
      const stateText = stateMeta.cardText || stateMeta.text || "现行";
      const verPart = ver ? `v${String(ver).replace(/^v/i, "")} ` : "";
      return `(${verPart}${stateText}版本 - 只读)`;
    },
    viewMode() {
      const src = this.dataSource;
      if (!src) return "empty";
      if (src.kind === "object" || src.kind === "resource") return "fields";
      return "table";
    },
    fieldItems() {
      if (this.viewMode !== "fields") return [];
      const data = this.applyData || {};
      let labels = { ...(BASIC_EXTRA_FIELDS[this.type] || {}), ...this.fieldLabels };
      // 思政微课补充材料：按类型展示可预览字段
      if (this.type === "3" && this.activeId === "WKSP") {
        labels = this.buildCourseMaterialLabels(data);
      }
      // 基本信息优先按设计常见顺序排一部分
      const prefer =
        this.type === "1"
          ? [
              "name",
              "applyYear",
              "orgName",
              "principals",
              "phone",
              "belongDepartment",
              "address",
              "foundTime",
              "acreage",
              "studioStatus",
              "tsSzgzsKnow",
              "tsSzgzsSatisfied",
              "reportNum",
              "conmunicateNum",
              "declarationName",
              "letterOfCommitmentName",
              "activityPlanName",
            ]
          : this.type === "3" && this.activeId === "WKJIBENXINXI"
          ? [
              "name",
              "applyYear",
              "foundTime",
              "basicMajorCategory",
              "basicMajorSubclass",
              "basicMajor",
              "course",
              "courseType",
              "wkStudyNum",
              "levelType",
              "declarationName",
              "applyNameId",
            ]
          : this.type === "2" && this.activeId === "PPJIBENXINXI"
          ? [
              "name",
              "applyYear",
              "belongDepartment",
              "foundTime",
              "brandClassify",
              "brandLabels",
              "basicMajorCategory",
              "basicMajorSubclass",
              "basicMajor",
              "declarationName",
              "activityPlanName",
              "brandConnotation",
            ]
          : Object.keys(labels);
      const keys = [
        ...prefer.filter((k) => labels[k]),
        ...Object.keys(labels).filter((k) => !prefer.includes(k)),
      ];
      return keys
        .map((key) => {
          const value = this.formatValue(key, data[key], data);
          const clickable = this.isFieldClickable(key, data);
          return {
            key,
            label: labels[key],
            value,
            clickable,
            evidence: this.isEvidenceField(key),
            path: this.getFieldPath(key, data),
          };
        })
        .filter((item) => item.value !== "" && item.value != null);
    },
    /** 两列一组，便于整行画底边线 */
    fieldRows() {
      const items = this.fieldItems;
      const rows = [];
      for (let i = 0; i < items.length; i += 2) {
        rows.push(items.slice(i, i + 2));
      }
      return rows;
    },
    antColumns() {
      const preset = getModuleTableColumns(this.activeId);
      const base = preset
        ? preset.map((c) => ({ ...c }))
        : Object.keys(this.fieldLabels).map((key) => ({
            title: this.fieldLabels[key],
            dataIndex: key,
            key,
            align: "center",
          }));
      const cols = base.map((c) => {
        if (c.dataIndex === "__seq") {
          return {
            ...c,
            scopedSlots: { customRender: "seq" },
          };
        }
        if (this.isTableFileColumn(c.dataIndex)) {
          return {
            ...c,
            customRender: (text, record) =>
              this.renderFileCell(text, record, c.dataIndex),
          };
        }
        return {
          ...c,
          customRender: (text, record) =>
            this.formatTableCell(text, record, c),
        };
      });
      // 列表模块：只读查看 + 佐证材料
      if (this.isRowViewModule) {
        cols.push({
          title: "操作",
          key: "action",
          align: "center",
          width: 180,
          scopedSlots: { customRender: "action" },
        });
      }
      return cols;
    },
    tableRows() {
      return (this.listRows || []).map((row, idx) => ({
        ...row,
        id: row.id || `row-${idx}`,
      }));
    },
    tableScroll() {
      const cols = this.antColumns || [];
      const total = cols.reduce((sum, c) => sum + (Number(c.width) || 140), 0);
      return total > 900 ? { x: total } : undefined;
    },
    isEmpty() {
      if (this.viewMode === "fields") return !this.fieldItems.length;
      if (this.viewMode === "table") return !this.total && !this.tableRows.length;
      return true;
    },
    tablePagination() {
      if (this.viewMode !== "table") return false;
      return {
        current: this.pageNo,
        pageSize: this.pageSize,
        total: this.total,
        showSizeChanger: true,
        showTotal: (t) => `共 ${t} 条`,
        pageSizeOptions: ["10", "20", "50"],
      };
    },
    isSnapshotMode() {
      return (
        this.snapshotMode ||
        !!(
          this.snapshotState &&
          (this.snapshotState.base || this.snapshotState.modules)
        )
      );
    },
    resolvedState() {
      if (
        this.snapshotState &&
        (this.snapshotState.base || this.snapshotState.modules)
      ) {
        return this.snapshotState;
      }
      return null;
    },
  },
  watch: {
    applyId: {
      immediate: true,
      handler(val) {
        if (val) this.bootstrap();
      },
    },
    applyType() {
      if (this.applyId) this.bootstrap();
    },
    snapshotState: {
      deep: true,
      handler() {
        if (this.applyId) this.bootstrap();
      },
    },
  },
  methods: {
    buildCourseMaterialLabels(data) {
      const isLink = String(data.type) === "1";
      const labels = {
        typeText: "补充视频类型",
      };
      if (isLink) {
        labels.name = "超链接名称";
        labels.filePath = "思政微课超链接";
      } else {
        labels.name = "思政微课视频";
      }
      labels.ideologicalElement = "思政元素";
      return labels;
    },
    isFieldClickable(key, data) {
      if (this.type === "3" && this.activeId === "WKSP") {
        if (key === "name" || key === "fileName") {
          return !!(data.aliId || data.filePath) && String(data.type) !== "1";
        }
        if (key === "filePath") {
          return !!data.filePath && String(data.type) === "1";
        }
      }
      const conf = this.fileViewMap[key];
      if (!conf) return false;
      const path = data[conf.urlName];
      return !!(data[key] && path);
    },
    getFieldPath(key, data) {
      if (this.type === "3" && this.activeId === "WKSP") {
        if (key === "filePath") return data.filePath || "";
        if (key === "name" || key === "fileName") {
          return data.filePath || data.aliId || "";
        }
      }
      const conf = this.fileViewMap[key];
      if (conf) return data[conf.urlName] || "";
      return "";
    },
    onFieldClick(item) {
      if (!item || !item.clickable) return;
      const data = this.applyData || {};
      if (this.type === "3" && this.activeId === "WKSP") {
        if (item.key === "filePath" && String(data.type) === "1") {
          this.openLink(data.filePath);
          return;
        }
        if (item.key === "name" || item.key === "fileName") {
          this.openVideo(data);
          return;
        }
      }
      const conf = this.fileViewMap[item.key];
      if (!conf) return;
      const path = data[conf.urlName];
      const title = conf.name || data[item.key] || item.value;
      this.openFilePreview(path, title);
    },
    isTableFileColumn(dataIndex) {
      return !!(dataIndex && this.fileViewMap[dataIndex]);
    },
    renderFileCell(text, record, dataIndex) {
      const conf = this.fileViewMap[dataIndex];
      const label =
        text != null && text !== ""
          ? String(text)
          : this.formatTableCell(text, record, { dataIndex }) || "-";
      if (!conf) return label;
      const path = record[conf.urlName];
      if (!path) return label;
      return this.$createElement(
        "a",
        {
          style: { color: "#e5914b", cursor: "pointer" },
          on: {
            click: (e) => {
              if (e && e.stopPropagation) e.stopPropagation();
              this.openFilePreview(path, conf.name || label);
            },
          },
        },
        label
      );
    },
    openFilePreview(path, name) {
      if (!path) return;
      const s = String(path).toLowerCase();
      if (s.includes(".mp4")) {
        this.openVideo({ filePath: path, aliId: "" });
        return;
      }
      this.openPdf(path, name);
    },
    openPdf(path, name) {
      if (!path) return;
      this.previewTitle = name || "文件预览";
      this.previewUrl = path;
      this.showPdf = true;
    },
    onChildPreviewFile(payload) {
      const path = payload && (payload.path || payload.url);
      if (!path) return;
      this.openPdf(path, (payload && payload.title) || "文件预览");
    },
    openVideo(row) {
      if (!row) return;
      this.videoData = {
        aliId: row.aliId || "",
        filePath: row.filePath || "",
      };
      this.showVideo = true;
    },
    openLink(url) {
      if (!url) return;
      const href = /^https?:\/\//i.test(url) ? url : `http://${url}`;
      window.open(href, "_blank");
    },
    seeRecord(record) {
      const conf = ROW_VIEW_MODULES[this.activeId];
      if (!conf) return;
      const ref = this.$refs[conf.ref];
      if (!ref || !ref.init) return;
      ref.init("see", record);
    },
    isEvidenceField(key) {
      return (
        this.type === "1" &&
        this.activeId === "GZSJIBENXINXI" &&
        (key === "reportNum" || key === "conmunicateNum")
      );
    },
    showFieldEvidence(item) {
      const map = {
        reportNum: {
          title: "项目被省级或国家级媒体报道次数",
          code: "xxbsjhgjjmtbdcs",
        },
        conmunicateNum: {
          title: "省内外同类院校前来交流学习次数",
          code: "snwtlyxqljlxxcs",
        },
      };
      const meta = item && map[item.key];
      if (!meta) return;
      this.evidenceQuery = {
        title: meta.title,
        code: meta.code,
        dataId: "",
      };
      this.evidenceRecord = {};
      this.showEvidenceBox = true;
    },
    showEvidence(record) {
      const conf = ROW_VIEW_MODULES[this.activeId];
      const dataId =
        (record && (record.id || record.dataId || record.sjId)) || "";
      this.evidenceQuery = {
        title: (conf && conf.title) || this.activeTitle || "佐证材料",
        code: "",
        dataId: dataId ? String(dataId) : "",
      };
      this.evidenceRecord = record || {};
      this.showEvidenceBox = true;
    },
    parseBrandLabels(raw) {
      if (raw == null || raw === "" || raw === "null") return [];
      if (Array.isArray(raw)) return raw;
      if (typeof raw === "string") {
        try {
          const parsed = JSON.parse(raw);
          return Array.isArray(parsed) ? parsed : [];
        } catch (e) {
          return [];
        }
      }
      return [];
    },
    findBrandLabelNode(nodes, id) {
      const list = nodes || [];
      for (let i = 0; i < list.length; i++) {
        const node = list[i];
        if (
          String(node.id) === String(id) ||
          String(node.name) === String(id)
        ) {
          return node;
        }
        const child = this.findBrandLabelNode(node.children, id);
        if (child) return child;
      }
      return null;
    },
    formatBrandLabelPaths(labels) {
      return (labels || [])
        .map((path) => {
          const ids = Array.isArray(path) ? path : [path];
          const names = ids.map((id) => {
            const hit = this.findBrandLabelNode(this.brandLabelTree || [], id);
            return (hit && hit.name) || String(id);
          });
          return names.filter(Boolean).join("/");
        })
        .filter(Boolean)
        .join("、");
    },
    resolveBrandLabels(p) {
      if (this.type !== "2" || !p) {
        this.brandLabelText = "";
        return;
      }
      const labels = this.parseBrandLabels(p.brandLabels);
      if (!labels.length) {
        this.brandLabelText = "";
        return;
      }
      const applyText = () => {
        this.brandLabelText = this.formatBrandLabelPaths(labels);
      };
      if ((this.brandLabelTree || []).length) {
        applyText();
        return;
      }
      getAction("/lxbase/lxBrandLabel/treeList", {})
        .then((res) => {
          if (res.code === 200 || res.code === 0) {
            this.brandLabelTree = res.result || [];
          }
          applyText();
        })
        .catch(() => {
          applyText();
        });
    },
    isBlank(v) {
      return v === null || v === undefined || v === "" || v === "null";
    },
    textOrEmpty(v) {
      return this.isBlank(v) ? "" : String(v);
    },
    unwrapList(res) {
      if (!res) return [];
      const ok = res.code === 200 || res.code === 0 || res.success === true;
      if (!ok) return [];
      const r = res.result;
      if (Array.isArray(r)) return r;
      if (r && Array.isArray(r.records)) return r.records;
      if (r && Array.isArray(r.list)) return r.list;
      return [];
    },
    pickName(list, id) {
      if (this.isBlank(id)) return "";
      const hit = (list || []).find(
        (item) =>
          String(item.id) === String(id) || String(item.value) === String(id)
      );
      if (!hit) return "";
      return this.textOrEmpty(
        hit.name ||
          hit.title ||
          hit.text ||
          hit.categoryName ||
          hit.subclassName ||
          hit.majorName
      );
    },
    majorIdOf(val) {
      if (this.isBlank(val)) return "";
      if (typeof val === "object") {
        return this.textOrEmpty(val.id || val.value);
      }
      const s = String(val);
      if (/[\u4e00-\u9fa5]/.test(s)) return "";
      return s;
    },
    displayMajorValue(val) {
      if (this.isBlank(val)) return "";
      if (typeof val === "object") {
        return this.textOrEmpty(
          val.name ||
            val.title ||
            val.text ||
            val.categoryName ||
            val.subclassName ||
            val.majorName
        );
      }
      const s = String(val);
      if (/[\u4e00-\u9fa5]/.test(s)) return s;
      return "";
    },
    majorFieldLabel(row, field, val) {
      const r = row || {};
      const extra =
        field === "basicMajorCategory"
          ? r.categoryName
          : field === "basicMajorSubclass"
          ? r.subclassName
          : r.majorName;
      return (
        this.textOrEmpty(r[`${field}_dictText`]) ||
        this.textOrEmpty(r[`${field}DictText`]) ||
        this.textOrEmpty(r[`${field}Name`]) ||
        this.displayMajorValue(val != null ? val : r[field]) ||
        this.textOrEmpty(extra)
      );
    },
    async fillMajorDictOnRows(rows) {
      const list = (rows || []).map((row) => ({ ...row }));
      if (!list.length) return list;
      const need = list.filter((row) => {
        const hasId =
          this.majorIdOf(row.basicMajorCategory) ||
          this.majorIdOf(row.basicMajorSubclass) ||
          this.majorIdOf(row.basicMajor);
        const missing =
          this.isBlank(this.majorFieldLabel(row, "basicMajorCategory")) ||
          this.isBlank(this.majorFieldLabel(row, "basicMajorSubclass")) ||
          this.isBlank(this.majorFieldLabel(row, "basicMajor"));
        return hasId && missing;
      });
      if (!need.length) {
        return list.map((row) => this.stampMajorDict(row));
      }
      const categoryIds = [
        ...new Set(
          need.map((row) => this.majorIdOf(row.basicMajorCategory)).filter(Boolean)
        ),
      ];
      const subclassIds = [
        ...new Set(
          need.map((row) => this.majorIdOf(row.basicMajorSubclass)).filter(Boolean)
        ),
      ];
      let categories = [];
      const subclassMap = {};
      const majorMap = {};
      try {
        const res = await getAction(
          "/infrastructure/basicMajorCategory/allList",
          {}
        );
        categories = this.unwrapList(res);
      } catch (e) {
        categories = [];
      }
      await Promise.all(
        categoryIds.map((cid) =>
          getAction("/infrastructure/basicMajorSubclass/queryByCategoryId", {
            gategoryId: cid,
          })
            .then((res) => {
              subclassMap[cid] = this.unwrapList(res);
            })
            .catch(() => {
              subclassMap[cid] = [];
            })
        )
      );
      await Promise.all(
        subclassIds.map((sid) =>
          getAction("/infrastructure/basicMajor/queryBySubclassId", {
            subclassId: sid,
          })
            .then((res) => {
              majorMap[sid] = this.unwrapList(res);
            })
            .catch(() => {
              majorMap[sid] = [];
            })
        )
      );
      return list.map((row) => {
        const categoryId = this.majorIdOf(row.basicMajorCategory);
        const subclassId = this.majorIdOf(row.basicMajorSubclass);
        const majorId = this.majorIdOf(row.basicMajor);
        if (this.isBlank(this.majorFieldLabel(row, "basicMajorCategory")) && categoryId) {
          row.basicMajorCategory_dictText = this.pickName(
            categories,
            categoryId
          );
        }
        if (this.isBlank(this.majorFieldLabel(row, "basicMajorSubclass")) && subclassId) {
          row.basicMajorSubclass_dictText = this.pickName(
            subclassMap[categoryId] || [],
            subclassId
          );
        }
        if (this.isBlank(this.majorFieldLabel(row, "basicMajor")) && majorId) {
          row.basicMajor_dictText = this.pickName(
            majorMap[subclassId] || [],
            majorId
          );
        }
        return this.stampMajorDict(row);
      });
    },
    stampMajorDict(row) {
      const next = { ...row };
      const category = this.majorFieldLabel(
        next,
        "basicMajorCategory",
        next.basicMajorCategory
      );
      const subclass = this.majorFieldLabel(
        next,
        "basicMajorSubclass",
        next.basicMajorSubclass
      );
      const major = this.majorFieldLabel(next, "basicMajor", next.basicMajor);
      if (category) next.basicMajorCategory_dictText = category;
      if (subclass) next.basicMajorSubclass_dictText = subclass;
      if (major) next.basicMajor_dictText = major;
      const courseType = this.courseTypeLabel(next.courseType, next);
      if (courseType) next.courseType_dictText = courseType;
      return next;
    },
    dictItemLabel(item) {
      if (!item || typeof item !== "object") return "";
      return this.textOrEmpty(
        item.title || item.text || item.label || item.name
      );
    },
    buildDictMap(list) {
      const map = {};
      (list || []).forEach((item) => {
        const label = this.dictItemLabel(item);
        if (!item || this.isBlank(label)) return;
        if (!this.isBlank(item.value)) map[String(item.value)] = label;
        if (!this.isBlank(item.id)) map[String(item.id)] = label;
      });
      return map;
    },
    loadCourseTypeDict() {
      return getAction("/baseCommon/getDictItemsByCode?code=course_type", {})
        .then((res) => {
          this.courseTypeMap = this.buildDictMap(this.unwrapList(res));
        })
        .catch(() => {
          this.courseTypeMap = {};
        });
    },
    courseTypeLabel(val, row) {
      const r = row || {};
      const fromDict =
        this.textOrEmpty(r.courseType_dictText) ||
        this.textOrEmpty(r.courseTypeDictText) ||
        this.textOrEmpty(r.courseTypeName);
      if (fromDict && /[\u4e00-\u9fa5]/.test(fromDict)) return fromDict;
      if (this.isBlank(val) && this.isBlank(r.courseType)) {
        return fromDict;
      }
      const raw = this.isBlank(val) ? r.courseType : val;
      if (typeof raw === "object") {
        return this.dictItemLabel(raw);
      }
      const s = this.textOrEmpty(raw);
      if (/[\u4e00-\u9fa5]/.test(s)) return s;
      return (
        this.textOrEmpty(this.courseTypeMap && this.courseTypeMap[s]) ||
        fromDict
      );
    },
    async enrichListMajorDict() {
      if (this.activeId !== "WKJIBENXINXI") return;
      this.listRows = await this.fillMajorDictOnRows(this.listRows);
    },
    resolveMajorNames(p) {
      // 思政微课、特色文化育人品牌、工作室下挂微课都有专业三级
      if (!p) return;
      const categoryId = this.majorIdOf(p.basicMajorCategory);
      const subclassId = this.majorIdOf(p.basicMajorSubclass);
      const majorId = this.majorIdOf(p.basicMajor);
      const names = {
        category: this.majorFieldLabel(
          p,
          "basicMajorCategory",
          p.basicMajorCategory
        ),
        subclass: this.majorFieldLabel(
          p,
          "basicMajorSubclass",
          p.basicMajorSubclass
        ),
        major: this.majorFieldLabel(p, "basicMajor", p.basicMajor),
      };
      this.majorNames = { ...names };
      if (names.category && names.subclass && names.major) return;

      const tasks = [];
      if (categoryId && !names.category) {
        tasks.push(
          getAction("/infrastructure/basicMajorCategory/allList", {})
            .then((res) => {
              names.category = this.pickName(this.unwrapList(res), categoryId);
            })
            .catch(() => {})
        );
      }
      if (categoryId && subclassId && !names.subclass) {
        tasks.push(
          getAction("/infrastructure/basicMajorSubclass/queryByCategoryId", {
            gategoryId: categoryId,
          })
            .then((res) => {
              names.subclass = this.pickName(this.unwrapList(res), subclassId);
            })
            .catch(() => {})
        );
      }
      if (subclassId && majorId && !names.major) {
        tasks.push(
          getAction("/infrastructure/basicMajor/queryBySubclassId", {
            subclassId,
          })
            .then((res) => {
              names.major = this.pickName(this.unwrapList(res), majorId);
            })
            .catch(() => {})
        );
      }
      if (!tasks.length) {
        this.majorNames = { ...names };
        return;
      }
      Promise.all(tasks).then(() => {
        this.majorNames = { ...names };
      });
    },
    async bootstrap() {
      this.activeId = (this.modules[0] && this.modules[0].id) || "";
      this.listRows = [];
      this.nestCache = {};
      this.pageNo = 1;
      this.total = 0;
      if (this.snapshotMode) {
        this.applyData = {
          ...((this.snapshotState && this.snapshotState.base) || {}),
        };
      } else {
        this.applyData = {};
      }
      if (this.type === "2") {
        await this.loadBrandLabelTree();
      }
      await this.loadCourseTypeDict();
      this.resolveMajorNames(this.applyData);
      this.resolveBrandLabels(this.applyData);
      this.fetchChangeHint();
      await this.loadModuleData();
    },
    fetchChangeHint() {
      this.changeHint = "";
      if (this.isSnapshotMode || !this.applyId) return;
      const role = this.$store.state.role;
      if (role !== "teacher-role" && role !== "school-role") return;
      getModuleChangeCount(this.applyId)
        .then((res) => {
          if (!(res.code === 200 || res.code === 0)) return;
          const draft =
            sumPendingReviewNum(res.result, true) -
            sumPendingReviewNum(res.result, false);
          const pending = sumPendingReviewNum(res.result, false);
          if (draft > 0 && pending > 0) {
            this.changeHint = `有 ${draft} 条待提交草稿、${pending} 条待审核变更。现状只显示已通过内容，点此查看变更请求。`;
          } else if (draft > 0) {
            this.changeHint = `有 ${draft} 条待提交变更草稿。现状只显示已通过内容，点此查看变更请求。`;
          } else if (pending > 0) {
            this.changeHint = `有 ${pending} 条待审核变更。现状只显示已通过内容，点此查看变更请求。`;
          }
        })
        .catch(() => {});
    },
    goRequests() {
      this.$router.replace({
        query: { ...this.$route.query, tab: "requests" },
      });
    },
    /** 拉取品牌文化树，供现状页把 brandLabels 的 id 路径还原为名称 */
    loadBrandLabelTree() {
      return getAction("/lxbase/lxBrandLabel/treeList", {})
        .then((res) => {
          if (!(res.code === 200 || res.code === 0)) return;
          const tree = res.result || [];
          this.brandLabelTree = tree;
          const map = {};
          const walk = (nodes) => {
            (nodes || []).forEach((n) => {
              if (n && n.id != null) {
                map[String(n.id)] = n.name || n.label || String(n.id);
              }
              if (n && n.children && n.children.length) walk(n.children);
            });
          };
          walk(tree);
          this.brandLabelMap = map;
        })
        .catch(() => {
          this.brandLabelTree = [];
          this.brandLabelMap = {};
        });
    },
    /**
     * brandLabels 存的是级联路径 id 数组（或 JSON 字符串），
     * 展示为「父级 / 子级、父级 / 子级」，与 dataUpload 级联选择一致
     */
    formatBrandLabels(val, row) {
      if (row && row.brandLabelsText) return String(row.brandLabelsText);
      if (row && row.brandLabels_dictText) {
        return String(row.brandLabels_dictText);
      }
      let paths = val;
      if (typeof paths === "string") {
        const s = paths.trim();
        if (!s) return "";
        try {
          paths = JSON.parse(s);
        } catch (e) {
          return s;
        }
      }
      if (!Array.isArray(paths) || !paths.length) return "";
      const map = this.brandLabelMap || {};
      return paths
        .map((path) => {
          const ids = Array.isArray(path) ? path : [path];
          return ids
            .map((id) => map[String(id)] || String(id))
            .filter(Boolean)
            .join(" / ");
        })
        .filter(Boolean)
        .join("、");
    },
    selectModule(id) {
      if (this.activeId === id) return;
      this.activeId = id;
      this.pageNo = 1;
      this.loadModuleData();
    },
    onTableChange(pagination) {
      if (!pagination) return;
      this.pageNo = pagination.current || 1;
      this.pageSize = pagination.pageSize || this.pageSize;
      this.loadModuleData();
    },
    snapshotModuleRows(taskType) {
      const state = this.resolvedState || {};
      const modules = state.modules || {};
      return modules[taskType] || [];
    },
    applySnapshotPage(allRows) {
      const all = allRows || [];
      this.total = all.length;
      const start = (this.pageNo - 1) * this.pageSize;
      this.listRows = all.slice(start, start + this.pageSize);
    },
    async loadModuleFromSnapshot() {
      const src = this.dataSource;
      this.listRows = [];
      this.total = 0;
      if (!src || !this.activeId) return;
      const state = this.resolvedState || {};
      if (src.kind === "object") {
        this.applyData = { ...(state.base || {}) };
        return;
      }
      if (src.kind === "resource") {
        const rows = this.snapshotModuleRows(this.activeId);
        this.applyData = { ...(state.base || {}), ...(rows[0] || {}) };
        return;
      }
      let rows = this.snapshotModuleRows(this.activeId);
      if (!rows.length && this.activeId === "GZSJIDIHUODONG") {
        const nested = [];
        (this.snapshotModuleRows("GZSSHIJIANJIDI") || []).forEach((row) => {
          (row.practiceBaseList || []).forEach((item) => nested.push(item));
        });
        rows = nested;
      }
      this.applySnapshotPage(rows);
      await this.enrichListMajorDict();
    },
    async loadModuleData() {
      const src = this.dataSource;
      this.listRows = [];
      if (!src || !this.activeId) return;
      if (this.isSnapshotMode) {
        await this.loadModuleFromSnapshot();
        this.resolveMajorNames(this.applyData);
        this.resolveBrandLabels(this.applyData);
        return;
      }
      if (!src.url) return;
      this.loading = true;
      try {
        if (src.kind === "object" || src.kind === "resource") {
          const res = await getAction(src.url, { applyId: this.applyId });
          const data =
            res && (res.code === 200 || res.code === 0) ? res.result || {} : {};
          this.applyData = { ...data };
          this.total = 0;
          this.resolveMajorNames(this.applyData);
          this.resolveBrandLabels(this.applyData);
          return;
        }
        const res = await getAction(src.url, {
          applyId: this.applyId,
          pageNo: this.pageNo,
          pageSize: this.pageSize,
        });
        const result =
          res && (res.code === 200 || res.code === 0) ? res.result || {} : {};
        this.listRows = result.records || [];
        this.total = Number(result.total) || 0;
        if (result.current) this.pageNo = Number(result.current) || this.pageNo;
        if (result.size) this.pageSize = Number(result.size) || this.pageSize;
        await this.enrichListMajorDict();
      } catch (e) {
        this.listRows = [];
        this.total = 0;
      } finally {
        this.loading = false;
      }
    },
    formatValue(key, val, row) {
      if (key === "typeText") {
        return String((row && row.type) || val) === "1" ? "超链接" : "本地视频";
      }
      if (key === "brandClassify") {
        if (String(val) === "0") return "校园文化品牌";
        if (String(val) === "1") return "专业文化品牌";
        return this.textOrEmpty(val);
      }
      if (key === "brandLabels") {
        if (this.brandLabelText) return this.brandLabelText;
        const fromMap = this.formatBrandLabels(val, row);
        if (fromMap) return fromMap;
        const labels = this.parseBrandLabels(val);
        if (!labels.length) return "";
        return this.formatBrandLabelPaths(labels) || "";
      }
      if (key === "basicMajorCategory") {
        return (
          this.majorFieldLabel(row, "basicMajorCategory", val) ||
          this.textOrEmpty(this.majorNames && this.majorNames.category)
        );
      }
      if (key === "basicMajorSubclass") {
        return (
          this.majorFieldLabel(row, "basicMajorSubclass", val) ||
          this.textOrEmpty(this.majorNames && this.majorNames.subclass)
        );
      }
      if (key === "basicMajor") {
        return (
          this.majorFieldLabel(row, "basicMajor", val) ||
          this.textOrEmpty(this.majorNames && this.majorNames.major)
        );
      }
      if (key === "course" || key === "ideologicalElement") {
        if (Array.isArray(val)) {
          return val.filter((x) => x && x !== "null").join("、");
        }
        if (typeof val === "string" && val && val !== "null") {
          return val.split(",").filter(Boolean).join("、");
        }
        return "";
      }
      if (key === "courseType") {
        return this.courseTypeLabel(val, row);
      }
      if (key === "name" && this.activeId === "WKSP") {
        if (String((row && row.type) || "") === "1") {
          return this.textOrEmpty(val);
        }
        if (val) return String(val);
        if (row && (row.aliId || row.filePath)) return "已上传";
        return "";
      }
      if (val === null || val === undefined || val === "") return "";
      if (key === "studioStatus") {
        return String(val) === "0" || val === true ? "开" : "关";
      }
      if (
        key === "izResponse" ||
        key === "izDedicated" ||
        key === "izPolitical" ||
        key === "izBsxw"
      ) {
        if (val === true || val === "是" || String(val) === "1") return "是";
        if (val === false || val === "否" || String(val) === "0") return "否";
        return String(val);
      }
      if (key === "sex") {
        if (val === "1" || val === 1 || val === "男") return "男";
        if (val === "2" || val === 2 || val === "女") return "女";
        return String(val);
      }
      if (key === "acreage" && val !== "") return `${val} 平米`;
      if (
        (key === "tsSzgzsKnow" || key === "tsSzgzsSatisfied") &&
        val !== ""
      ) {
        return `${val}%`;
      }
      if (typeof val === "object") return JSON.stringify(val);
      const dictText = row && row[`${key}_dictText`];
      if (dictText !== null && dictText !== undefined && dictText !== "") {
        return String(dictText);
      }
      return String(val);
    },
    formatTableCell(text, record, column) {
      const key = (column && (column.dataIndex || column.key)) || "";
      if (key === "__seq") return "";
      // 优先 *_dictText
      if (key && key.endsWith("_dictText")) {
        const rawKey = key.replace(/_dictText$/, "");
        const dictVal = record[key];
        if (!this.isBlank(dictVal)) {
          return String(dictVal);
        }
        return this.formatValue(rawKey, record[rawKey], record) || "-";
      }
      // 若有同名字典字段也优先
      const dict = record[`${key}_dictText`];
      if (!this.isBlank(dict)) {
        return String(dict);
      }
      const formatted = this.formatValue(key, text != null ? text : record[key], record);
      return formatted === "" || formatted == null ? "-" : formatted;
    },
  },
};
</script>

<style lang="scss" scoped>
.ps-current {
  display: flex;
  gap: 16px;
  min-height: 360px;
  font-family: "Microsoft YaHei", "微软雅黑", sans-serif;
}

.ps-current__side {
  width: 200px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;

  &.has-prepend {
    width: 240px;
  }

  &-prepend {
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-bottom: 8px;
    padding-bottom: 16px;
    border-bottom: 1px solid #eee;
  }

  &-title {
    font-size: 14px;
    color: #8b8b8b;
    padding: 0 4px 4px;
  }

  &-item {
    position: relative;
    display: flex;
    align-items: center;
    width: 100%;
    min-height: 40px;
    padding: 8px 28px 8px 14px;
    border: 1px solid #e5e5e5;
    border-radius: 6px;
    background: #fff;
    color: #333;
    font-size: 14px;
    text-align: left;
    cursor: pointer;
    font-family: inherit;
    box-sizing: border-box;
    transition: background 0.15s, border-color 0.15s, color 0.15s;

    &:hover {
      border-color: #8aafff;
      color: #2563eb;
    }

    &.active {
      background: #2563eb;
      border-color: #2563eb;
      color: #fff;
    }
  }

  &-text {
    line-height: 1.35;
  }

  &-arrow {
    position: absolute;
    right: 10px;
    top: 50%;
    width: 0;
    height: 0;
    border-top: 5px solid transparent;
    border-bottom: 5px solid transparent;
    border-left: 6px solid #fff;
    transform: translateY(-50%);
  }
}

.ps-current__main {
  flex: 1;
  min-width: 0;
  padding: 4px 8px 8px 12px;

  &-head {
    display: flex;
    align-items: flex-end;
    gap: 8px;
    margin-bottom: 12px;
  }

  &-bar {
    width: 4px;
    height: 22px;
    background: #2563eb;
    border-radius: 1px;
    flex-shrink: 0;
    align-self: center;
  }

  &-title {
    margin: 0;
    font-size: 20px;
    font-weight: 700;
    color: #2563eb;
    line-height: 1.2;
    font-family: "Microsoft YaHei", "微软雅黑", sans-serif;
  }

  &-ver {
    font-size: 14px;
    color: #9ca3af;
    font-weight: 400;
    line-height: 1.2;
    /* 与标题文字底边对齐，略补中文下沉差 */
    transform: translateY(-1px);
  }
}

.ps-current__fields {
  display: flex;
  flex-direction: column;
}

.ps-current__field-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0 40px;
  padding: 14px 0;
  border-bottom: 1px solid #e8e8e8;
}

.ps-current__field {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;

  &--placeholder {
    visibility: hidden;
  }

  &-label {
    font-size: 13px;
    color: #9ca3af;
  }

  &-value {
    font-size: 15px;
    color: #111;
    line-height: 1.45;
    word-break: break-all;
    &.is-link {
      display: inline;
      padding: 0;
      border: none;
      background: none;
      color: #e5914b;
      cursor: pointer;
      text-align: left;
      text-decoration: underline;
      font: inherit;
      &:hover {
        color: #c46d2a;
      }
    }
  }
}

.ps-current__evidence {
  margin-left: 10px;
  color: #e5914b;
  cursor: pointer;
  font-size: 13px;
  white-space: nowrap;
}

.ps-current__act {
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  color: #e5914b;
  margin: 0 6px;
  font-size: 14px;
  &:hover {
    color: #c46d2a;
  }
}

.ps-file-preview-body {
  height: 72vh;
  margin: -24px;
}

.preview-pop-box {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 1000;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  .preview-boxs {
    width: 80%;
    max-width: 1100px;
    height: 90%;
    background: #fff;
    border-radius: 8px;
    overflow: hidden;
  }
}

.ps-current__table-wrap {
  overflow-x: auto;
}

.ps-current__atable {
  ::v-deep .ant-table-thead > tr > th {
    background: #fafafa;
    text-align: center;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.85);
  }
  ::v-deep .ant-table-tbody > tr > td {
    text-align: center;
  }
}

.ps-current__empty {
  text-align: center;
  color: #9ca3af;
  padding: 48px 20px;
  font-size: 14px;
}

.ps-current__hint {
  margin: -6px 0 16px;
  padding: 10px 14px;
  background: #fff7ed;
  border: 1px solid #fdba74;
  border-radius: 8px;
  color: #c2410c;
  font-size: 14px;
  cursor: pointer;
  line-height: 1.5;
  &:hover {
    background: #ffedd5;
  }
}

@media (max-width: 900px) {
  .ps-current {
    flex-direction: column;
  }
  .ps-current__side {
    width: 100%;
    flex-direction: row;
    flex-wrap: wrap;
    &.has-prepend {
      width: 100%;
      flex-direction: column;
      flex-wrap: nowrap;
    }
  }
  .ps-current__side-prepend {
    width: 100%;
  }
  .ps-current__side-item {
    width: auto;
    flex: 1 1 140px;
  }
  .ps-current__side.has-prepend .ps-current__side-item {
    width: 100%;
    flex: none;
  }
  .ps-current__field-row {
    grid-template-columns: 1fr;
  }
}
</style>
<style lang="scss">
.ps-file-preview-modal {
  .ant-modal-body {
    padding: 0;
  }
}
</style>
